function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.297 1.53C14.805.543 11.982 0 9.346 0 6.633 0 3.805.535 1.382 1.505c-.867.352-1.016.971-.866 1.433l.173.434a.683.683 0 00.91.371c.461-.203 1.022-.45 1.153-.502 1.879-.78 4.167-1.192 6.613-1.192 2.453 0 4.614.395 6.607 1.206.188.077.635.274 1.117.49A.683.683 0 0018 3.377l.159-.39.014-.038c.148-.436.006-1.07-.876-1.42z",
  fill: "#50A684"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.904 4.647c-1.943-.782-4.333-1.232-6.558-1.232-2.245.002-4.47.42-6.563 1.233a6.924 6.924 0 00-.183.08.683.683 0 00-.342.909c.171.372.403.878.662 1.447 1.405 3.076 4.02 8.797 5.218 11.273a1.355 1.355 0 001.227.768 1.355 1.355 0 001.228-.771l.002-.005 5.862-12.704a.679.679 0 00-.355-.915c-.097-.041-.165-.07-.192-.08l-.006-.003zM6.722 8.193a1.366 1.366 0 11-.178-2.726 1.366 1.366 0 01.178 2.726zm2.732 5.465a1.366 1.366 0 11-.178-2.727 1.366 1.366 0 01.178 2.727zm2.732-4.782a1.366 1.366 0 11-.178-2.726 1.366 1.366 0 01.178 2.726z",
  fill: "#50A684"
});

function SvgGreenPizza(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGreenPizza;